import { IImposedFinesAPIState } from "../types/imposedFines.types";

export const IMPOSED_FINES_INITIAL_STATE: IImposedFinesAPIState = {
  data: {
    list: [],
    totalPages: 0,
    totalRecords: 0,
  },
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  list: [],
  loading: false,
  error: null,
  searchFine: {},
};
